module.exports = __webpack_public_path__ + "static/media/angle-down-black.6b339cb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/angle-down-black.svg
// module id = 239
// module chunks = 0